var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.getHideIcons)?_c('v-list-item-avatar',_vm._g({attrs:{"tile":""}},{ ..._vm.$listeners }),[_vm._t("default",null,null,_vm.$attrs)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }